var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 294,
    viewBox: "0 0 426 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 426,
    height: 294,
    fill: "#FDF7ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.0121 142.427H87.9728C78.9437 142.427 71.6245 149.729 71.6245 158.737V248.232C71.6245 257.24 78.9437 264.542 87.9728 264.542H143.401C152.43 264.542 159.749 257.24 159.749 248.232",
    stroke: "#455A64",
    strokeWidth: 1.1031,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.41 4.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.204 57.9834V40.3049C155.204 34.7884 159.687 30.3159 165.216 30.3159H237.299C242.828 30.3159 247.311 34.7884 247.311 40.3049",
    stroke: "#455A64",
    strokeWidth: 1.1031,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.41 4.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.657 81.7027V215.608C354.657 224.722 347.249 232.114 338.114 232.114H102.05C92.9142 232.114 85.5056 224.722 85.5056 215.608V81.7027C85.5056 81.3093 85.522 80.9233 85.5548 80.5381C86.1467 71.9658 93.3085 65.1895 102.049 65.1895H338.113C346.853 65.1895 354.015 71.9658 354.607 80.5381C354.641 80.9233 354.657 81.3093 354.657 81.7027Z",
    stroke: "#FAAE20",
    strokeWidth: 1.1031,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.945 225.889H109.06C100.497 225.889 93.5559 218.963 93.5559 210.42V86.7241H347.45V210.42C347.45 218.963 340.508 225.889 331.945 225.889Z",
    fill: "#FCE5BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M347.454 86.7231V210.423C347.454 218.963 340.585 225.886 332.122 225.886H108.888C100.426 225.886 93.5559 218.963 93.5559 210.423V86.7231H347.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.608 80.5381H85.5549C86.1468 71.9658 93.3087 65.1895 102.049 65.1895H338.113C346.854 65.1895 354.015 71.965 354.608 80.5381Z",
    fill: "#FAAE20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.617 72.8633C118.617 74.4778 117.305 75.7867 115.687 75.7867C114.069 75.7867 112.757 74.4778 112.757 72.8633C112.757 71.2488 114.069 69.9399 115.687 69.9399C117.305 69.9399 118.617 71.2488 118.617 72.8633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.008 72.8633C131.008 74.4778 129.696 75.7867 128.078 75.7867C126.46 75.7867 125.148 74.4778 125.148 72.8633C125.148 71.2488 126.46 69.9399 128.078 69.9399C129.696 69.9399 131.008 71.2488 131.008 72.8633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.468 75.7867C142.087 75.7867 143.398 74.4778 143.398 72.8633C143.398 71.2488 142.087 69.9399 140.468 69.9399C138.85 69.9399 137.538 71.2488 137.538 72.8633C137.538 74.4778 138.85 75.7867 140.468 75.7867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.209 105.86C346.124 105.253 344.965 104.777 343.764 104.441L342.374 98.2314H336.454L335.073 104.441C333.864 104.769 332.705 105.253 331.62 105.86L326.275 102.447L322.09 106.623L325.453 111.955C324.836 113.046 324.359 114.203 324.031 115.401L317.806 116.779V122.685L324.031 124.071C324.359 125.285 324.836 126.45 325.453 127.541L322.032 132.906L326.218 137.082L331.595 133.669C332.68 134.284 333.839 134.76 335.048 135.096L336.43 141.298H342.35L343.739 135.096C344.94 134.76 346.099 134.276 347.184 133.669L347.456 133.841V105.703L347.209 105.86ZM339.431 127.394C335.204 127.394 331.784 123.982 331.784 119.765C331.784 115.557 335.204 112.136 339.431 112.136C343.657 112.136 347.078 115.557 347.078 119.765C347.078 123.982 343.657 127.394 339.431 127.394Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.544 111.842V99.3894L227.42 96.4853C226.704 93.9583 225.702 91.5139 224.419 89.2167L226.006 86.7231H164.065L165.594 89.1512C164.303 91.4402 163.3 93.8765 162.602 96.411L149.478 99.3232V111.776L162.602 114.696C163.301 117.248 164.303 119.709 165.594 122.014L158.383 133.327L167.214 142.129L178.545 134.935C180.848 136.223 183.29 137.232 185.83 137.945L188.741 151.021H201.223L204.158 137.945C206.69 137.231 209.125 136.214 211.418 134.935L222.757 142.129L231.58 133.327L224.418 122.014C225.693 119.717 226.704 117.289 227.419 114.763L240.544 111.842ZM195.072 121.703C186.167 121.703 178.948 114.501 178.948 105.616C178.948 96.7315 186.167 89.529 195.072 89.529C203.978 89.529 211.197 96.7315 211.197 105.616C211.197 114.501 203.978 121.703 195.072 121.703Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.754 197.352L158.281 187.476L148.018 184.588C147.541 182.562 146.834 180.585 145.913 178.715L152.113 170.027L145.469 162.668L136.178 167.91C134.401 166.803 132.51 165.892 130.521 165.212L128.744 154.711L118.845 154.186L115.983 164.457C113.944 164.908 111.971 165.613 110.096 166.541L101.396 160.356L94.0123 166.984L99.2748 176.262C98.1403 178.026 97.2354 179.913 96.5616 181.897L93.5605 182.39V195.77L95.7394 196.385C96.2 198.428 96.9067 200.404 97.8444 202.275L93.5605 208.255L93.8483 213.382V213.415L93.8565 213.423L98.2723 218.313L107.58 213.071C109.356 214.211 111.264 215.13 113.253 215.802L114.947 225.884V225.892L115.029 226.311L124.929 226.836L125.192 225.892V225.884L127.79 216.565C129.846 216.106 131.819 215.409 133.71 214.481L142.394 220.658L149.778 214.038L144.531 204.752C145.65 202.988 146.555 201.101 147.212 199.125L157.754 197.352ZM131.458 181.921C126.721 176.671 118.614 176.245 113.352 180.969C108.089 185.695 107.662 193.783 112.398 199.033C117.134 204.283 125.241 204.701 130.504 199.976C135.766 195.252 136.194 187.172 131.458 181.921Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.928 182.593C237.313 181.064 237.512 179.492 237.529 177.915L244.647 174.182L242.68 166.977L234.646 167.352C233.833 166.001 232.861 164.748 231.76 163.631L234.141 155.963L227.653 152.255L222.226 158.163C220.699 157.79 219.131 157.594 217.552 157.569L213.795 150.462L206.584 152.42L206.965 160.445C205.61 161.256 204.354 162.226 203.227 163.322L195.539 160.954L191.818 167.416L197.772 172.816C197.388 174.345 197.191 175.909 197.185 177.481L190.054 181.227L192.021 188.432L200.066 188.052C200.868 189.408 201.832 190.658 202.942 191.778L200.55 199.406L207.038 203.114L212.437 197.256C213.97 197.64 215.537 197.836 217.121 197.845L220.869 204.957L228.08 203L227.764 196.145L227.71 194.97C229.08 194.164 230.343 193.197 231.484 192.089L239.167 194.471L242.342 188.935L242.883 187.998L236.928 182.593ZM219.879 186.969C214.726 188.368 209.418 185.334 208.021 180.204C206.619 175.064 209.66 169.768 214.802 168.374C219.954 166.975 225.262 170.009 226.66 175.139C228.062 180.279 225.02 185.576 219.879 186.969Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.456 195.264L321.1 185.379L311.069 181.351C310.838 179.243 310.353 177.175 309.63 175.182L316.849 167.16L311.003 159.005L301.045 163.222C299.393 161.901 297.592 160.786 295.668 159.891L295.084 149.111L285.168 147.479L281.106 157.446C279.001 157.693 276.937 158.177 274.948 158.891L266.881 151.688L258.716 157.521L262.95 167.447C261.783 168.907 260.772 170.466 259.933 172.124C259.818 172.353 259.703 172.583 259.596 172.813L248.8 173.412L247.155 183.288L248.783 183.945L257.187 187.325C257.417 189.417 257.894 191.484 258.626 193.469L251.406 201.517L257.253 209.663L267.21 205.43C268.855 206.767 270.664 207.891 272.58 208.786L273.139 219.516L283.047 221.149L287.1 211.255C289.213 211.026 291.286 210.542 293.275 209.812L301.325 217.023L309.498 211.182L305.263 201.247C306.612 199.598 307.755 197.785 308.66 195.858L319.456 195.264ZM291.655 194.821C285.825 198.98 277.718 197.643 273.549 191.827C269.372 186.019 270.721 177.93 276.542 173.771C282.372 169.604 290.48 170.949 294.648 176.757C298.825 182.573 297.477 190.662 291.655 194.821Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.104 249.223H107.152C101.755 249.223 97.3794 244.857 97.3794 239.473V131.794C97.3794 126.41 101.754 122.044 107.152 122.044H185.104C190.501 122.044 194.876 126.41 194.876 131.794V239.473C194.876 244.858 190.501 249.223 185.104 249.223Z",
    fill: "#FAAE20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.953 141.4V249.078C203.953 254.468 199.578 258.832 194.176 258.832H116.225C110.831 258.832 106.456 254.469 106.456 249.078V141.4C106.456 136.019 110.83 131.654 116.225 131.654H194.176C199.578 131.654 203.953 136.018 203.953 141.4Z",
    fill: "white",
    stroke: "#455A64",
    strokeWidth: 1.1031,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.702 141.443V147.08H106.5V141.443C106.5 136.184 110.861 131.918 116.239 131.918H193.955C199.341 131.918 203.702 136.183 203.702 141.443Z",
    fill: "#FAAE20",
    stroke: "#455A64",
    strokeWidth: 1.1031,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.611 153.847H115.625V157.86H139.611V153.847Z",
    fill: "#FAAE20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.611 189.832H115.625V193.845H139.611V189.832Z",
    fill: "#FAAE20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.611 222.464H115.625V226.477H139.611V222.464Z",
    fill: "#FAAE20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.75 163.784H115.625V166.728H183.75V163.784Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.465 169.418H115.625V172.288H171.465V169.418Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.778 174.958H115.625V177.827H178.778V174.958Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.778 180.492H115.625V183.361H178.778V180.492Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.75 196.416H115.625V199.36H183.75V196.416Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.465 202.051H115.625V204.92H171.465V202.051Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.778 207.59H115.625V210.459H178.778V207.59Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.75 232.25H115.625V235.195H183.75V232.25Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.465 237.885H115.625V240.754H171.465V237.885Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.778 243.425H115.625V246.294H178.778V243.425Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.828 56.9909V100.511C313.828 106.934 308.614 112.135 302.176 112.135H201.704C195.274 112.135 190.053 106.934 190.053 100.511V56.9909C190.053 50.5678 195.274 45.3584 201.704 45.3584H302.176C308.614 45.3584 313.828 50.5678 313.828 56.9909Z",
    fill: "white",
    stroke: "#455A64",
    strokeWidth: 1.1031,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.828 56.9909V57.9837H190.053V56.9909C190.053 50.5678 195.274 45.3584 201.704 45.3584H302.176C308.614 45.3584 313.828 50.5678 313.828 56.9909Z",
    fill: "#FAAE20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.236 53.7505C207.539 54.4458 206.409 54.4458 205.712 53.7505C205.015 53.0552 205.015 51.9278 205.712 51.2324C206.409 50.5371 207.539 50.5371 208.236 51.2324C208.933 51.9278 208.933 53.0552 208.236 53.7505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.525 53.7505C215.828 54.4458 214.698 54.4458 214.001 53.7505C213.304 53.0552 213.304 51.9278 214.001 51.2324C214.698 50.5371 215.828 50.5371 216.525 51.2324C217.222 51.9278 217.222 53.0552 216.525 53.7505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.814 53.7505C224.117 54.4458 222.987 54.4458 222.29 53.7505C221.593 53.0552 221.593 51.9278 222.29 51.2324C222.987 50.5371 224.117 50.5371 224.814 51.2324C225.511 51.9278 225.511 53.0552 224.814 53.7505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.404 65.9863H197.945V100.878H238.404V65.9863Z",
    stroke: "#455A64",
    strokeWidth: 1.1031,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.41 4.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.21 65.9863H244.647V68.4367H291.21V65.9863Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.364 71.0679H244.647V73.5183H280.364V71.0679Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.834 76.1201H244.647V78.5995H297.834V76.1201Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.936 81.0566H244.647V83.536H289.936V81.0566Z",
    fill: "#455A64"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 284,
    height: 235,
    fill: "white",
    transform: "translate(71 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.03f1631721ed397a28bc36f73083d92a.svg";
export { ForwardRef as ReactComponent };